import React, {Fragment, memo} from 'react';

import RouteToStore from '../routing/route-to-store';


/** @type {import("@mapsight/ui/src/js/components/contexts").AdditionalContainerContent} */
const AdditionalContainerContent = memo(
	function AdditionalContainerContent({children}) {
		return (
			<Fragment>
				<RouteToStore />
				{children}
			</Fragment>
		);
	}
);

export default AdditionalContainerContent;
